var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallratiobackspread(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 34H58",
    stroke: "#E6E6E6",
    strokeLinecap: "round",
    strokeDasharray: "4 5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 38H46.5L60 24.5V18L40 38Z",
    fill: "#12B16E",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2566 38H7V42.5H30.5L36 48.5L51 33.5H44.5L36 42L32.2566 38Z",
    fill: "#E94C69"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 38V37.5H6.5V38H7ZM32.2566 38L32.6216 37.6583C32.5271 37.5573 32.3949 37.5 32.2566 37.5V38ZM51 33.5L51.3536 33.8536L52.2071 33H51V33.5ZM36 48.5L35.6314 48.8379L35.9843 49.2228L36.3536 48.8536L36 48.5ZM30.5 42.5L30.8686 42.1621L30.72 42H30.5V42.5ZM7 42.5H6.5V43H7V42.5ZM36 42L35.6349 42.3417L35.9881 42.719L36.3536 42.3536L36 42ZM44.5 33.5V33H44.2929L44.1464 33.1464L44.5 33.5ZM7 38.5H32.2566V37.5H7V38.5ZM50.6464 33.1464L35.6464 48.1464L36.3536 48.8536L51.3536 33.8536L50.6464 33.1464ZM36.3686 48.1621L30.8686 42.1621L30.1314 42.8379L35.6314 48.8379L36.3686 48.1621ZM30.5 42H7V43H30.5V42ZM7.5 42.5V38H6.5V42.5H7.5ZM31.8915 38.3417L35.6349 42.3417L36.3651 41.6583L32.6216 37.6583L31.8915 38.3417ZM36.3536 42.3536L44.8536 33.8536L44.1464 33.1464L35.6464 41.6464L36.3536 42.3536ZM44.5 34H51V33H44.5V34Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.5V53.5",
    stroke: "#E6E6E6",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallratiobackspread);
export default __webpack_public_path__ + "static/media/Call ratio back spread.ddbfddb29870e9449ed2e9a65ee2eb93.svg";
export { ForwardRef as ReactComponent };